import React from 'react';
import { Container, Typography, Box, Grid, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import Layout from './Layout';
import { colors } from '../colors';

const Resources = () => {
    return (
        <Layout>
        {/* Blue Banner */}
      <Box
        sx={{
          backgroundColor: colors.primaryBannerBlue,
          color: 'white',
          padding: { xs: '5px 0', sm: '10px 0' }, // Responsive padding
          textAlign: 'center',
          fontSize: { xs: '1rem', sm: '1.2rem' },
          fontWeight: '500',
        }}
      >
        RESOURCES
      </Box>
            <Container maxWidth="lg" sx={{ mt: 5 }}>

                {/* Hero Section */}
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1.5 }}
                >
                    <Box
                        sx={{
                            background: 'linear-gradient(135deg, #F8C7C3, #F4D8C2)',  // Dark blue header background
                            color: 'white',
                            padding: '50px 20px',
                            textAlign: 'center',
                            borderRadius: '10px',
                            boxShadow: '0 6px 15px rgba(0, 0, 0, 0.1)',  // Soft shadow effect
                        }}
                    >
                        <Typography variant="h3" 
                        gutterBottom
                        sx={{
                                fontWeight: 'bold',  // Bold text for the title
                                letterSpacing: '1px',  // Slightly spaced letters for a more elegant feel
                                color: colors.racineRedDark,  // Coral red for the title to stay within your theme
                            }}
                        >
                            Resources for International Research
                        </Typography>
                        <Typography variant="h6" sx={{  
                                color: colors.primaryApplicationText,  // Coral red for the title to stay within your theme
                            }}>
                            Explore our curated resources that help organizations conduct research and analyze data globally.
                        </Typography>
                    </Box>
                </motion.div>

                {/* Resource List Section */}
                <motion.div
                    initial={{ x: '-100vw' }}
                    animate={{ x: 0 }}
                    transition={{ type: 'spring', stiffness: 120 }}
                >
                    <Box textAlign="center" mt={8}>
                        <Typography variant="h4" gutterBottom>
                            Our Resources
                        </Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={4}>
                                <Paper
                                    elevation={3}
                                    sx={{
                                        padding: '20px',
                                        backgroundColor: '#FAFAFA',
                                        borderLeft: `5px solid ${colors.racineRedDark}`,
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        '&:hover': { transform: 'scale(1.05)', transition: 'transform 0.3s ease' },
                                    }}
                                >
                                    <Typography variant="h6" sx={{ color: colors.racineRedDark }}>Whitepapers</Typography>
                                    <Typography sx={{ color: '#333333' }}>
                                        Access our comprehensive collection of research whitepapers on global topics.
                                    </Typography>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Paper
                                    elevation={3}
                                    sx={{
                                        padding: '20px',
                                        backgroundColor: '#FAFAFA',
                                        borderLeft: `5px solid ${colors.racineRedDark}`,
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        '&:hover': { transform: 'scale(1.05)', transition: 'transform 0.3s ease' },
                                    }}
                                >
                                    <Typography variant="h6" sx={{ color: colors.racineRedDark }}>Case Studies</Typography>
                                    <Typography sx={{ color: '#333333' }}>
                                        Discover case studies highlighting successful research methodologies.
                                    </Typography>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Paper
                                    elevation={3}
                                    sx={{
                                        padding: '20px',
                                        backgroundColor: '#FAFAFA',
                                        borderLeft: `5px solid ${colors.racineRedDark}`,
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        '&:hover': { transform: 'scale(1.05)', transition: 'transform 0.3s ease' },
                                    }}
                                >
                                    <Typography variant="h6" sx={{ color: colors.racineRedDark }}>Guides</Typography>
                                    <Typography sx={{ color: '#333333' }}>
                                        Get expert guides to plan, execute, and analyze your research effectively.
                                    </Typography>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Box>
                </motion.div>
            </Container>
        </Layout>
    );
};

export default Resources;
